export function getFriendlyName(value) {
    const friendlyNames = {
        "from.funnel.card.field.change": "Quando um campo é atualizado",
        "to.funnel.card.change.qualify": "Alterar qualificação do card",
        "to.chat.create": "Criar chat",
        "card_criado": "Quando um Card é Criado",
        "card_saiu_estagio": "Quando um Card Sai de um Estágio",
        "card_entrou_estagio": "Quando um Card Entra em um Estágio",
        "inatividade_card_funil": "Inatividade no Card no Funil",
        "chat_aceito": "Qunado um é Chat Aceito",
        "chat_palavra_chave": "Qunado há uma Palavra-Chave no Chat",
        "chat_direcionado": "Chat Direcionado",
        "mover_card_funil": "Mover Card para Funil",
        "atualizar_campo": "Atualizar Campo",
        "criar_nota_chat": "Criar Nota no Chat",
        "qualificar_lead": "Qualificar Lead",
        "criar_card": "Criar Card",
        "criar_chat": "Criar Chat",
        "adicionar_etiqueta": "Adicionar Etiqueta",
        "enviar_msg_chat": "Enviar Mensagem no Chat",
        "distribuir_responsaveis": "Distribuir Responsáveis",
        "to.httpRequest": "Criar requisição HTTP",
        "to.chat.sendMessage": "Enviar mensagem no chat",
        "to.funnel.changeUser": "Alterar usuário do card no funil",
        "to.chat.addNote": "Adicionar nota no chat",
        "from.funnel.card.out.stage": "Quando um card sai de um estágio",
        "from.chat.create": "Quando um chat é criado",
      };
    return friendlyNames[value] || value;
  }
  
